// extracted by mini-css-extract-plugin
export var iframe = "styles-module--iframe--XdfWc";